export const signupActivationForm = 'signupActivationForm';
export const signupEmailForm = 'signupEmailForm';
export const signupAboutForm = 'signupAboutForm';
